import React from "react"
import "./styles.scss"

const JioimmerseDesktopTnc = () => {
  return (
    <>
      <div
        className="tnc-jioimmerse-wrapper-desktop"
        spellCheck="false"
        tabIndex={0}
        contentEditable="false"
      >
        <div className="tnc-jioimmerse-wrapper-desktop-info">
          <h3 id="tnc-jioimmerse-wrapper-inner">
            Terms & Conditions for JioImmerse Desktop&nbsp;
          </h3>
        </div>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <strong>1. SCOPE:&nbsp;</strong>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">1.1&nbsp;</li>
          <li>
            JioImmerse Desktop application is a laptop and/ or desktop
            compatible application (
            <b style={{ color: "black", fontWeight: "700" }}>‘Application’</b>),
            owned, operated and provided by Tesseract Imaging Limited and/or its
            affiliates (
            <b style={{ color: "black", fontWeight: "700" }}>
              “Company”, “we,” “us” and “our”
            </b>
            ) located at T22C, Reliance Corporate Park, Ghansoli, Navi Mumbai
            400 701, India.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">1.2&nbsp;</li>
          <li>
            The Application is designed and made available by the Company and
            /or its affiliates to provide its users services such as (i)
            extended display for laptops/ desktops (up to three virtual
            displays) on devices provided by the Company to provide users with
            an augmented reality, virtual reality and/ or mixed reality
            experience; and (ii) such other services as may be provided by the
            Company from time to time at its sole discretion (collectively known
            as <b style={{ color: "black", fontWeight: "700" }}>“Services”</b>)
            on compatible laptops/ desktops powered by Windows operating system
            and/ or Mac operating system (“Device”). The list of such compatible
            Devices shall be made available by the Company from time to time.
            This Application has been devised for usage along with the augmented
            reality, virtual reality and/ or mixed reality products of the
            Company and/ or its affiliates.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">1.3&nbsp;</li>
          <li>
            Please read these Terms and Conditions (
            <b style={{ color: "black", fontWeight: "700" }}>“Terms”</b>), along
            with the Privacy Policy (defined below) and all other rules and
            policies made available or published by the Company.Your (
            <b style={{ color: "black", fontWeight: "700" }}>
              “you”, “your” or “user”
            </b>
            ) use of the Application is subject to these Terms and Conditions,
            the Privacy Policy and all other rules and policies made available
            or published by the Company.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">1.4&nbsp;</li>
          <li>
            Your use of the Application on the Device requires that you agree to
            these Terms and the Privacy Policy of the Application. By
            downloading the Application and by registering or signing up to the
            Application, or otherwise having access to, receiving, and/or using
            the Application, you acknowledge to have read, understood and you
            consent to be governed and bound by these Terms and the Privacy
            Policy of the Application. If you do not understand the Terms or the
            privacy policy of the Application, or do not accept any part of
            them, then you should not use the Application.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">1.5&nbsp;</li>
          <li>
            The Terms are an electronic record in terms of the Information
            Technology Act, 2000 (as amended / re-enacted) (“IT Act”) and rules
            thereunder, and is published in accordance with the provisions of
            Rule 3 (1) (a) of Information Technology (Intermediary Guidelines
            and Digital Media Ethics Code) Rules, 2021, which mandates for
            publishing of rules and regulations, privacy policy and terms of use
            for access or usage of Application. This electronic record is
            generated by a computer system and does not require any physical or
            digital signatures.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">1.6&nbsp;</li>
          <li>
            Subject to these Terms, we may offer to provide you with the
            Services selected by you, solely for your own use, and not for the
            use or benefit of any third party. In case of any discrepancy in the
            Services, you must bring the same to our notice in writing within a
            period of 7 (Seven) days from the date of performance of the
            Services, failing which the Services shall be deemed accepted,
            fulfilled and satisfactorily completed.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <strong>2. PRIVACY AND PROTECTION OF PERSONAL INFORMATION:</strong>
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">2.1&nbsp;</li>
          <li>
            Please refer to the privacy policy of the Application available here
            (
            <b style={{ color: "black", fontWeight: "700" }}>
              “Privacy Policy”
            </b>
            ).
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">2.2&nbsp;</li>
          <li>
            Please note that your use of the Application or Services on your
            Device and download thereof from Microsoft Store (in case of Windows
            OS supported laptops/ desktops) or Apple App Store (in case of Mac
            OS supported laptops/ desktops), as the case maybe, may be subject
            to the respective privacy policies as may be published or made
            available by the Device and Microsoft Store and/ or Apple App Store,
            as the case maybe. The Company shall not be liable for any terms,
            conditions, or obligations imposed by these third-party platforms,
            and you acknowledge that your compliance with such policies is your
            sole responsibility.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <strong>3. MODIFICATIONS:</strong>
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">3.1&nbsp;</li>
          <li>
            Modifications of the Terms: The Company reserves the right to change
            the Terms under which the Services are offered, including but not
            limited to the charges, if any, associated with the use of the
            Services. The Terms may be further modified based on changes in the
            business, legal and regulatory requirements and will be updated
            online. We will notify you whenever any change to the Terms and
            Conditions are made. You are encouraged to periodically visit this
            page to review these Terms and any changes to it. The Company shall
            not be liable for any consequences, losses, or damages resulting
            from your failure to review the updated Terms or from any reliance
            on the information contained herein.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">3.2&nbsp;</li>
          <li>
            Modification of Services: The Company reserves the right to add,
            modify or delete any content or features available in the Services
            at any time at its sole discretion. The Company may implement these
            changes without prior notice, and any such alterations shall not
            give rise to any liability on the part of the Company for any
            disruptions or limitations of access that may occur as a result. You
            acknowledge and agree that the Company shall not be responsible for
            any impact, loss of data, or interruption of Services due to these
            modifications.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <strong>4. LINKS TO THIRD PARTY SITES AND APPLICATIONS:</strong>
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">4.1&nbsp;</li>
          <li>
            The Application may contain links to other websites/applications
            (“Linked Sites”). The Linked Sites are not under the control of the
            Company and the Company is not responsible for the contents of any
            Linked Site, including without limitation any link contained in a
            Linked Site, or any changes or updates to a Linked Site or any
            information transmitted on a Linked Site. The inclusion of any link
            does not imply endorsement by the Company of the site or any
            association with its operators.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">4.2&nbsp;</li>
          <li>
            Any dealings with third parties (including advertisers) included
            within or available via a link from the Application or participation
            in promotions, including the delivery of and the payment for goods
            and services, and any other terms, conditions, warranties or
            representations associated with such dealings or promotions, are
            solely between you and the advertiser or other third party. The
            Company shall not be responsible or liable for any part of any such
            dealings or promotions including but not limited to any damages,
            claims, or disputes arising from your interactions with third
            parties. You acknowledge that the Company has no obligation to
            intervene in any disputes between you and third parties.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">4.3&nbsp;</li>
          <li>
            You acknowledge and agree that the use of any Linked Sites is
            governed by such third party’s terms of use, license agreement,
            privacy policy, or other such agreement. THE COMPANY DISCLAIMS ANY
            AND ALL RESPONSIBILITY FOR ANY DISCLOSURE OF INFORMATION OR ANY
            OTHER PRACTICES OF ANY THIRD PARTY. THE COMPANY EXPRESSLY DISCLAIMS
            ANY WARRANTY WITH RESPECT TO YOUR PERSONAL OR OTHER INFORMATION THAT
            MAY BE COLLECTED, PROCESSED, SHARED OR RETAINED BY ANY THIRD PARTY
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">4.4&nbsp;</li>
          <li>
            Once you login on the Application, you may receive updates,
            promotional materials, and other information we may send with regard
            to the Service, or new services we may offer. You hereby consent to
            receiving all such commercial communications from us. You may opt
            out of receiving any, or all, of these commercial communications by
            writing to us at [●].
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">4.5&nbsp;</li>
          <li>
            You are encouraged to carefully read the terms of use and privacy
            policy, of any Linked Sites that you visit. The Company reserves the
            right to disable third-party links from the Application, although
            the Company is under no obligation to do so.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <strong>5. INTELLECTUAL PROPERTY RIGHTS: </strong>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">5.1&nbsp;</li>
          <li>
            The Company and/ or its affiliates shall own title, interest and
            rights, including all related intellectual property rights, in/of
            the Application including but not limited to object code of the
            Application, features of Services, which is/are protected by the
            applicable laws except the content owned by the user. You
            acknowledge that such ownership shall include all intellectual
            property rights arising from any suggestions, enhancement requests,
            recommendations or other information provided by the user, whether
            in the course of use of the Application, your Device or otherwise.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">5.2&nbsp;</li>
          <li>
            <b style={{ color: "black", fontWeight: "700" }}>
              Application License:
            </b>{" "}
            Subject to your strict and full compliance with the Terms, Company
            hereby grants you a revocable, non-exclusive, non-transferable,
            non-sub- licensable, limited license, to download, install and use
            the Application on Devices owned and controlled by you, strictly in
            accordance with the terms of the Terms. The Application includes (i)
            the software application in object code/source code that you may
            access and download and the scripts, interfaces, graphics, displays,
            text, documentation and other components/associated data and
            information made available to you as part of the software; and (ii)
            any updates, modifications, or enhancements to (i) or any part
            thereof, as may be provided by Company
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">5.3&nbsp;</li>
          <li>
            Except for the rights expressly stated herein, no other rights are
            granted to you with respect to the Application, either by
            implication, estoppel, or otherwise.
          </li>
        </ul>

        {/* 5th  */}
        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <strong>6. USE LIMITATIONS:</strong>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">6.1&nbsp;</li>
          <li>
            Services offered by the Application are intended solely for the
            purpose of availing Services provided by the Application. You may
            not distribute, transmit, display, perform, reproduce, publish,
            license, create derivative works from, transfer, or sell any
            information, software, products or Services offered by the
            Application.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">6.2&nbsp;</li>
          <li>
            As a condition of your use of the Application, you warrant to the
            Company that you will not use the Application for any purpose that
            is unlawful or prohibited by these Terms. You may not use the
            Application in any manner which could damage, disable, overburden or
            impair the Services or interfere with any other party's use and
            enjoyment of the Application.or cancellation of your access to the
            Content via the Application.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">6.3&nbsp;</li>
          <li>
            You are not entitled to use any kind of measures, mechanisms or
            tools (software or hardware) that could interfere with the
            functioning of the Application or any of its Services.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">6.4&nbsp;</li>
          <li>
            You may not use the Services and/or Application if (i) you have been
            convicted of any offence under applicable law; and/or (ii) if you
            are under the age of 18 years (subject to the below). If you are
            under the age of 18 years, you should review these Terms with your
            parent or legal guardian to make sure that you and your parent or
            legal guardian understand and agree to it and further if required
            your parent / legal guardian shall perform or undertake such
            activities to enter into a legally binding agreement with the
            Company.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">6.5&nbsp;</li>
          <li>
            Company is free at its sole discretion to use any comments,
            information, ideas, concepts, reviews, or techniques or any other
            material contained in any communication you may send to us (“User
            Feedback”), including responses to questionnaires or through
            postings to the Application and user submissions, without further
            compensation, acknowledgement or payment to you for any purpose
            whatsoever including, but not limited to, developing, manufacturing
            and marketing products and creating, modifying or improving the
            Application. By posting / submitting any User Feedback / user
            submission on the Application, you grant Company a perpetual,
            worldwide, non-exclusive, royalty-free irrevocable, sub-licensable
            license and right in such User Feedback / user submission to the
            Company, including the right to display, use, reproduce, or modify
            the User Feedback / user submission in any media, software or
            technology of any kind now existing or developed in the future.
            Company reserves the right to remove User Feedback / user submission
            at sole discretion and/or upon on request of any third party that
            such User Feedback / user submission may create liability for
            Company or harm the reputation of the Company or are offensive,
            inappropriate, defamatory, obscene or libelous in nature.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">6.6&nbsp;</li>
          <li>
            You agree that you will not upload on the Services, any content that
            is contrary to the Terms and the Company’s content guidelines, the
            Privacy Policy, or any other policy of Company, as updated from time
            to time, or that is contrary to applicable laws and regulations. If
            any such content is uploaded on the Services and in your account in
            any manner and for any reason whatsoever, you shall ensure that such
            content is deleted from the Services and your account immediately.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">6.7&nbsp;</li>
          <li>Further, by using the Application, you agree that:</li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(a)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;you have no rights in, or to, the Application or the
            technology used or supported by the Application or any of the
            Services, other than the right to use each of them in accordance
            with these Terms;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(b)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;you will not use the Application or the Services in any manner
            inconsistent with these Terms or Privacy Policy;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(c)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;you will not resell or make any commercial use of the Services
            or use the Services in any way that is unlawful, for any unlawful
            purpose, or in a manner that your use harms us, the Application, or
            any other person or entity, as determined in our sole discretion, or
            act fraudulently or maliciously;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(d)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;you will not decipher, decompile, disassemble, reverse
            engineer or otherwise attempt to derive any hardware, or source code
            or underlying ideas or algorithms of any part of the Service
            (including without limitation any application or widget), except to
            the limited extent applicable laws specifically prohibit such
            restriction;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(e)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;you will not transmit or make available any software or other
            computer files that contain a virus or other harmful component, or
            otherwise impair or damage the Application or any connected network,
            or otherwise damage, disable, overburden, impair or compromise the
            Application, our systems or security or interfere with any person or
            entity's use or enjoyment of the Application;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(f)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;you will not promote the use of explosives or firearms, the
            consumption of psychotropic drugs or any other illegal activities;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(g)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;you will not disparage, make false or malicious statements
            against us or in connection with the Services or the Application;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(h)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;you will not interfere or attempt to interfere with the proper
            working of the Application, or any activities conducted on the
            Application;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(i)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;you will not bypass any measures we may use to prevent or
            restrict access to the Services;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(j)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;you will not run any form of autoresponder or “spam” on the
            Application;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(k)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;you will not use manual or automated software, devices, or
            other processes to “crawl” or “spider” any part of the Services;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(l)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;you will not modify, adapt, appropriate, reproduce,
            distribute, translate, create derivative works or adaptations of,
            publicly display, republish, repurpose, sell, trade, or in any way
            exploit the Service, except as expressly authorized by us; or
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(m)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;you will not delete or modify any content of the Services,
            including but not limited to, legal notices, disclaimers or
            proprietary notices such as copyright or trademark symbols, logos,
            that you do not own or have express permission to modify.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <strong>7. USER NAMES AND PASSWORDS:</strong>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">7.1&nbsp;</li>
          <li>
            You may be required to register with the Application in order to
            access the Application using the means and methodology as provided
            by the Company from time to time. The user, while creating an
            account, hereby represents and warrants that all the information
            provided by the user is current, accurate and complete and that the
            user will maintain the accuracy and keep the information updated
            from time to time. If it is found that the information so supplied
            on the Application is inaccurate, incomplete, untrue and not
            current, we have the right to suspend or terminate the user’s
            account and restrict/refuse the use of the Application by such user
            in the future.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">7.2&nbsp;</li>
          <li>
            You are responsible for maintaining the confidentiality of any
            password including but not limited to one-time password you may use
            to access the Application and you agree not to transfer such
            passwords or user names or lend or otherwise transfer your use or
            access to this Application to any third party. You agree to notify
            us of any unauthorized use of your passwords or user names or any
            other breach of security related to your account of which you become
            aware. You are fully responsible for all use of the Application and
            any Services that occur in connection with your user name,. Also,
            the use of another user’s account information for availing the
            Services is expressly prohibited.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <strong>8. GENERAL:&nbsp;</strong>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">8.1&nbsp;</li>
          <li>
            By using our Services you hereby agree to ensure that the explicit
            prohibitions mentioned in section 8.3 are at all times adhered to.
            The Company may use and/ or develop advanced technologies to detect
            any misuse of our Services. The Company reserves the right to use
            and/ or develop automated means and/ or systems to improve our
            ability to detect and/ or remove any prohibited conduct that may be
            in violation of the applicable law and/ or may harm the integrity of
            our Services.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">8.2&nbsp;</li>
          <li>
            Use Restriction: You must not access the Application if you are a
            person who is either barred or otherwise legally prohibited from
            receiving or using the Service or any Services under the laws of
            India.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">8.3&nbsp;</li>
          <li>
            You shall not host, display, upload, modify, publish, transmit,
            update or share any information which:
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(a)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;Belongs to another person and to which you do not have any
            right to;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(b)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;Is obscene, pornographic, paedophilic, invasive of another‘s
            privacy, including bodily privacy, insulting or harassing on the
            basis of gender, libellous, racially or ethnically objectionable,
            relating or encouraging money laundering or gambling, or an online
            game that causes user harm, or promoting enmity between different
            groups on the grounds of religion or caste with the intent to incite
            violence;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(c)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;Deceives or misleads the addressee about the origin of the
            message or knowingly and intentionally communicates any
            misinformation or information which is patently false and untrue or
            misleading in nature or, in respect of any business of the Central
            Government, is identified as fake or false or misleading by such
            fact check unit of the Central Government as the Ministry may, by
            notification published in the Official Gazette, specify;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(d)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;Is patently offensive to the online community, such as
            sexually explicit content, or content that promotes obscenity,
            paedophilia, racism, bigotry, hatred or physical harm of any kind
            against any group or individual;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(e)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;Harassing or advocates harassment of another person;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(f)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;Involves the transmission of “junk mail”, “chained letters”,
            or unsolicited mass mailing or “spamming”;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(g)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;Promotes illegal activities;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(h)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;Infringes any patent, trademark, copyright or other
            proprietary rights;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(i)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;Is in the nature of advertisement or surrogate advertisement
            or promotion of an online game that is not a permissible online
            game, or of any online gaming intermediary offering such an online
            game;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(j)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;Provides instructional information about illegal activities
            such as making and/ or buying illegal weapons, violating someone’s
            privacy, or providing or creating computer viruses;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(k)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;Solicits gambling or engages in any gambling activity which we
            in our sole discretion believe is or could be construed to be as
            illegal;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(l)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;Is harmful to child;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(m)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;Violates any law for the time being in force;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(n)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;Impersonates another person;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(o)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;Contains software viruses or any other computer code, files or
            programs designed to interrupt, destroy or limit the functionality
            of any computer resource; or contains any trojan horses, worms, time
            bombs, cancelbots, easter eggs or other computer programming
            routines that may damage, detrimentally interfere with, diminish
            value of, surreptitiously intercept or expropriate any system, data
            or personal information; or
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">(p)</li>
          <li
            role="presentation"
            style={{ marginTop: "1rem !important;" }}
          >
            &nbsp;Threatens the unity, integrity, defence, security or
            sovereignty of India, friendly relations with foreign states, or
            public order or causes incitement to the commission of any
            cognizable offense or prevents investigation of any offense or is
            insulting any other nation.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">8.4&nbsp;</li>
          <li>
            Services may be made available for free of cost or for a specified
            cost as may be decided by the Company from time to time. The said
            fee terms are subject to periodic review and may be revised at our
            sole discretion with any revisions being communicated to you as
            necessary.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">8.5&nbsp;</li>
          <li>
            Third-Party Fees: You may incur access or data fees from third
            parties (such as your internet provider) in connection with your use
            of Services and of Application. You are solely responsible for all
            such fees.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">8.6&nbsp;</li>
          <li>
            Updates: You may need to install updates to the Application or
            related software that we introduce from time to time to use of the
            Application. Services originating from the Application may
            communicate with the servers from time to time to check for
            available updates to the Services and to the functionality of the
            Application, such as bug fixes, patches, enhanced functions, missing
            plug-ins and new versions (collectively, “Updates”). Your use of the
            Services you have installed requires that you have agreed to receive
            such automatically requested Updates. The Company reserves the right
            to modify, enhance, or discontinue the Application and its related
            Services, including any Updates, at its sole discretion and without
            prior notice. You acknowledge and agree that failure to install
            Updates may result in reduced functionality or compatibility of the
            Application, and the Company shall not be liable for any issues
            arising from your failure to comply with this requirement.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">8.7&nbsp;</li>
          <li>
            Accuracy of Information: You agree that the information entered by
            you while profile creation/ updation or using any of Services is
            true, current, complete and accurate in all respects. The Company is
            not responsible for any losses arising out of discrepancy in your
            data. You are solely responsible for maintaining confidentiality and
            security of your user account and for all activities that occur on
            or through your user account. The Company is not responsible for any
            losses arising out of the unauthorized use of your user account.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <strong>9. RESTRICTED CONTENT</strong>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">9.1&nbsp;</li>
          <li>
            You acknowledge that the Application allows to mirror content
            displayed on the user’s Device, with the content shown 'as-is'. We
            do not monitor, filter, or restrict content, and users are fully
            responsible for ensuring that the content they display complies with
            applicable laws and guidelines. Users are strictly prohibited from
            displaying harmful, illegal, or inappropriate content, including
            pornography, sexually explicit materials, content that promotes
            violence, hatred, discrimination, or illegal activities, as well as
            materials related to the sale of illegal substances or dangerous
            items.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <strong>10. INDEMNITY&nbsp;</strong>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">10.1&nbsp;</li>
          <li>
            You shall defend, indemnify and hold harmless, the Company, its
            affiliates, any third party networks / infrastructure providers and
            their respective directors, officers, personnel, contractors and
            agents, for and against any and all claims, suits, judgment, losses,
            damages, cost and expenses arising or relating to your use of the
            Application or your breach of the Terms or the Privacy Policy or any
            other restrictions or guidelines provided by the Company. This
            indemnification obligation will survive this Terms and your use of
            the Application.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <strong>11. LIABILITY DISCLAIMER:</strong>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">11.1&nbsp;</li>
          <li>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL
            THE COMPANY BE LIABLE TO YOU FOR ANY SPECIAL, INCIDENTAL, INDIRECT,
            PUNITIVE OR CONSEQUENTIAL DAMAGES WHATSOEVER (INCLUDING, WITHOUT
            LIMITATION, DAMAGES FOR LOSS OF USE, LOSS OF BUSINESS PROFITS,
            BUSINESS INTERRUPTION, LOSS OF INFORMATION, OR ANY OTHER PECUNIARY
            LOSS) ARISING OUT OF THE USE OF, OR INABILITY TO USE OR ACCESS, THE
            APPLICATION OR FOR ANY SECURITY BREACH OR ANY VIRUS, BUG,
            UNAUTHORIZED INTERVENTION, DEFECT, OR TECHNICAL MALFUNCTIONING OF
            THE APPLICATION, WHETHER OR NOT FORESEEABLE OR WHETHER OR NOT THE
            COMPANY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, OR
            BASED ON ANY THEORY OF LIABILITY, INCLUDING BREACH OF CONTRACT OR
            WARRANTY, NEGLIGENCE OR OTHER TORTIOUS ACTION, OR ANY OTHER CLAIM
            ARISING OUT, OF OR IN CONNECTION WITH, YOUR USE OF, OR ACCESS TO,
            THE APPLICATION OR THE CONTENT. FURTHER, THE COMPANY SHALL NOT BE
            LIABLE TO YOU FOR ANY TEMPORARY DISABLEMENT, PERMANENT
            DISCONTINUANCE OR MODIFICATION OF THE APPLICATION BY THE COMPANY OR
            FOR ANY CONSEQUENCES RESULTING FROM SUCH ACTIONS.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">11.2&nbsp;</li>
          <li>
            YOU SHALL BE SOLELY RESPONSIBLE FOR OBTAINING AND MAINTAINING ANY
            EQUIPMENT AND ANCILLARY SERVICES (INCLUDING THE PAYMENT OF ANY
            ADDITIONAL FEES THEREFORE) REQUIRED TO CONNECT TO, ACCESS OR
            OTHERWISE USE THE SERVICES, INCLUDING, WITHOUT LIMITATION, VIRTUAL
            REALITY DEVICES, VIDEO-ENABLED DEVICES, VIDEO COMMUNICATION
            SERVICES, MODEMS, HARDWARE, SERVERS, SOFTWARE, OPERATING SYSTEMS,
            NETWORKING, WEB SERVERS, INTERNET AND TELEPHONE SERVICE
            (COLLECTIVELY, “EQUIPMENT”). YOU WILL ALSO BE RESPONSIBLE FOR
            MAINTAINING THE SECURITY OF THE EQUIPMENT AND FOR ALL USES OF THE
            EQUIPMENT WITH OR WITHOUT YOUR KNOWLEDGE OR CONSENT
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">11.3&nbsp;</li>
          <li>
            YOU ARE SOLELY RESPONSIBLE FOR THE CONTENT AND OTHER MATERIALS YOU
            TRANSMIT THROUGH THE SERVICE OR SHARE WITH OTHER USERS OR
            RECIPIENTS. YOU WILL NOT TRANSMIT ANY CONTENT THAT YOU DID NOT
            CREATE OR THAT YOU DO NOT OWN ALL RIGHT, TITLE AND INTEREST IN AND
            TO, INCLUDING, WITHOUT LIMITATION, ALL COPYRIGHT AND RIGHTS OF
            PUBLICITY CONTAINED THEREIN.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">11.4&nbsp;</li>
          <li>
            THE COMPANY AND/OR ITS RESPECTIVE AFFILIATES MAKES NO
            REPRESENTATIONS ABOUT THE SUITABILITY, RELIABILITY, AVAILABILITY,
            TIMELINESS AND ACCURACY OF THE INFORMATION, SOFTWARE AND SERVICES
            AND RELATED CONTENT CONTAINED ON THE APPLICATION FOR ANY PURPOSE.
            ALL SUCH INFORMATION, SOFTWARE AND SERVICES AND RELATED CONTENT ARE
            PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND. THE COMPANY AND/OR
            ITS RESPECTIVE SUPPLIERS HEREBY DISCLAIMS ALL WARRANTIES AND
            CONDITIONS WITH REGARD TO THIS INFORMATION, SOFTWARE, AND SERVICES
            AND RELATED CONTENT, INCLUDING ALL IMPLIED WARRANTIES AND CONDITIONS
            OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE AND
            NON-INFRINGEMENT
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">11.5&nbsp;</li>
          <li>
            YOU SPECIFICALLY AGREE THAT THE COMPANY SHALL NOT BE RESPONSIBLE FOR
            UNAUTHORISED ACCESS TO OR ALTERATION OF YOUR TRANSMISSIONS OR DATA,
            ANY MATERIAL OR DATA SENT OR RECEIVED OR NOT SENT OR RECEIVED, OR
            ANY TRANSACTIONS ENTERED INTO THROUGH THE APPLICATION. YOU
            SPECIFICALLY AGREE THAT THE COMPANY IS NOT RESPONSIBLE OR LIABLE FOR
            ANY THREATENING, DEFAMATORY, OBSCENE, OFFENSIVE OR ILLEGAL SERVICES
            OR CONDUCT OF ANY OTHER PARTY OR ANY INFRINGEMENT OF ANOTHER'S
            RIGHTS, INCLUDING INTELLECTUAL PROPERTY RIGHTS. YOU SPECIFICALLY
            AGREE THAT THE COMPANY IS NOT RESPONSIBLE FOR ANY SERVICES SENT
            USING AND/OR INCLUDED IN THE APPLICATION BY ANY THIRD PARTY
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">11.6&nbsp;</li>
          <li>
            IN NO EVENT SHALL THE COMPANY AND/OR ITS AFFILIATES BE LIABLE FOR
            ANY DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, CONSEQUENTIAL
            DAMAGES OR ANY DAMAGES WHATSOEVER INCLUDING, WITHOUT LIMITATION,
            DAMAGES FOR OR IN RELATION TO: (A) LOSS OF USE, DATA OR PROFITS
            ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE USE OR PERFORMANCE
            OF APPLICATION; (B) ANY DELAY OR INABILITY TO USE THE APPLICATION OR
            SERVICES; (C) THE PROVISION OF OR FAILURE TO PROVIDE SERVICES, OR
            FOR ANY INFORMATION OR SERVICES OBTAINED THROUGH THE APPLICATION; OR
            (D) OTHERWISE ARISING OUT OF THE USE OF THE APPLICATION OR THE
            SERVICES OF THE COMPANY; WHETHER OR NOT ALL OF THE ABOVE LOSSES,
            CLAIMS OR DAMAGES ARE BASED ON CONTRACT, TORT, NEGLIGENCE, STRICT
            LIABILITY, EVEN IF THE COMPANY AND/OR ITS AFFILIATES AND/OR ITS
            ASSOCIATES HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH LOSSES,
            CLAIMS OR DAMAGES.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">11.7&nbsp;</li>
          <li>
            THE APPLICATION IS NOT INTENDED FOR USE BY INDIVIDUALS WITH MEDICAL
            CONDITIONS THAT MAY BE AGGRAVATED BY THE USE OF AUGMENTED REALITY,
            VIRTUAL REALITY, OR MIXED REALITY TECHNOLOGIES. USERS WITH
            PRE-EXISTING MEDICAL CONDITIONS, INCLUDING BUT NOT LIMITED TO
            EPILEPSY, SEIZURES, VISUAL IMPAIRMENTS, MOTION SICKNESS, OR ANY
            OTHER CONDITION THAT MAY BE TRIGGERED OR EXACERBATED BY PROLONGED
            USE OF SCREENS OR IMMERSIVE TECHNOLOGY, SHOULD CONSULT WITH A
            QUALIFIED MEDICAL PROFESSIONAL BEFORE USING THE APPLICATION. BY
            USING THE APPLICATION, YOU ACKNOWLEDGE AND AGREE THAT THE COMPANY IS
            NOT RESPONSIBLE FOR ANY ADVERSE HEALTH EFFECTS OR MEDICAL CONDITIONS
            THAT MAY ARISE FROM THE USE OF THE APPLICATION. THE COMPANY
            DISCLAIMS ANY AND ALL LIABILITY FOR INJURIES, HEALTH COMPLICATIONS,
            OR OTHER ISSUES THAT MAY RESULT FROM THE USE OF THE APPLICATION, AND
            YOU ASSUME FULL RESPONSIBILITY FOR YOUR HEALTH AND WELL-BEING WHILE
            USING THE APPLICATION.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">11.8&nbsp;</li>
          <li>
            THE COMPANY MAKES NO REPRESENTATION OR WARRANTY THAT THE CONTENT ON
            THE APPLICATION IS APPROPRIATE TO BE USED OR ACCESSED OUTSIDE THE
            REPUBLIC OF INDIA. ANY USERS WHO USE OR ACCESS THE APPLICATION OR
            AVAIL THE SERVICES FROM OUTSIDE THE REPUBLIC OF INDIA, DO SO AT
            THEIR OWN RISK AND ARE RESPONSIBLE FOR COMPLIANCE WITH THE LAWS OF
            SUCH JURISDICTION.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <strong>
              12. TERMINATION (TEMPORARY AND PERMANENT DISABLEMENT):
            </strong>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">&nbsp;12.1&nbsp;</li>
          <li>
            Unless otherwise provided in these Terms, the Services offered to
            you may be terminated by the Company without assigning any reasons
            at any time at the sole discretion of the Company without incurring
            any liability. Upon termination / suspension, you shall not have the
            right to use or access the Application/Services.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">&nbsp;12.2&nbsp;</li>
          <li>
            The Company reserves the right , at its sole discretion to suspend
            and/ or terminate your access to the Services in case of any
            non-adherence to these Terms and Privacy policy by you.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">&nbsp;12.3&nbsp;</li>
          <li>
            All provisions of these Terms which by their nature survive
            termination shall survive termination.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <strong>13. GOVERNING LAW AND DISPUTE RESOLUTION:</strong>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">&nbsp;13.1&nbsp;</li>
          <li>
            These Terms and Conditions are governed and construed in accordance
            with the laws of India, without regard to its conflict of law
            principles. The courts in Mumbai shall have exclusive jurisdiction
            to hear disputes arising out of these terms.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <strong>14. FORCE MAJEURE:</strong>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">&nbsp;14.1&nbsp;</li>
          <li>
            The Company shall be under no liability whatsoever in the event of
            non-availability of any portion of the Application or subscribed
            Services occasioned by act of God, war, disease, pandemics,
            epidemics, revolution, riot, civil commotion, strike, lockout,
            flood, fire, failure of any public utility, manmade disaster,
            infrastructure failure or any other cause whatsoever beyond the
            control of the Company. In any such event, the Company shall have
            the right to suspend or terminate the affected Services without any
            liability to you.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <strong>15. SEVERABILITY AND WAIVER:</strong>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">&nbsp;15.1&nbsp;</li>
          <li>
            If any of the provisions of these Terms are deemed invalid, void, or
            for any reason unenforceable, that part of these Terms will be
            deemed severable and will not affect the validity and enforceability
            of any remaining provisions of these Terms.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">&nbsp;15.2&nbsp;</li>
          <li>
            Any failure by Company to enforce the Terms, for whatever reason,
            shall not necessarily be construed as a waiver of any right to do so
            at any time.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <strong>16. CONTACT DETAILS:</strong>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">&nbsp;16.1&nbsp;</li>
          <li>
            If you have any questions or concerns regarding these Terms or
            require any support in relation to the Application, you may write to
            us at: Grievance Officer rt name], Reliance Corporate IT Park,
            TC-22, Thane Belapur Road, Ghansoli, Navi Mumbai 400701 Email id:
            grievance@tesseract.in
          </li>
        </ul>
      </div>
    </>
  )
}

export default JioimmerseDesktopTnc
